module.exports = __webpack_public_path__ + "static/media/photo.71af842f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Splash/images/photo.png
// module id = 1349
// module chunks = 0